import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appKitIdFormat]',
    standalone: false
})
export class KitIdFormatDirective {

  private regex: RegExp = new RegExp(/([A-Z a-z 0-9 @ # ,-])+/g);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = event.key;
    if (!current.match(this.regex)) {
      event.preventDefault();
    }
  }

}
